const swipeContainer_ucc = document.querySelector('.swipe-container_ucc');
const scrollThumb_ucc = document.querySelector('.scroll-thumb_ucc');
const customScrollbar_ucc = document.querySelector('.custom-scrollbar_ucc');
const numItems_ucc = swipeContainer_ucc?.children.length;
scrollThumb_ucc && (scrollThumb_ucc.style.left = `${100 / numItems_ucc}%`);

swipeContainer_ucc?.addEventListener('scroll', () => {
  const scrollPosition_ucc = swipeContainer_ucc.scrollLeft;
  const maxScroll_ucc = swipeContainer_ucc.scrollWidth - swipeContainer_ucc.clientWidth;
  const thumbPosition_ucc = (scrollPosition_ucc / maxScroll_ucc) * (100 - (100 / numItems_ucc));
  scrollThumb_ucc && (scrollThumb_ucc.style.left = `${thumbPosition_ucc}%`);
});

let isDragging_ucc = false;

customScrollbar_ucc?.addEventListener('mousedown', (e) => {
  isDragging_ucc = true;
  moveThumb_ucc(e);
});

window.addEventListener('mousemove', (e) => {
  if (isDragging_ucc) {
    moveThumb_ucc(e);
  }
});

window.addEventListener('mouseup', () => {
  isDragging_ucc = false;
});

function moveThumb_ucc(e) {
  const scrollbarRect_ucc = customScrollbar_ucc.getBoundingClientRect();
  const offsetX_ucc = e.clientX - scrollbarRect_ucc.left;
  const thumbWidth_ucc = scrollThumb_ucc.offsetWidth;
  const maxThumbPosition_ucc = scrollbarRect_ucc.width - thumbWidth_ucc;
  let thumbPosition_ucc = Math.min(Math.max(offsetX_ucc - thumbWidth_ucc / 2, 0), maxThumbPosition_ucc);
  const scrollPosition_ucc = (thumbPosition_ucc / maxThumbPosition_ucc) * (swipeContainer_ucc.scrollWidth - swipeContainer_ucc.clientWidth);
  scrollThumb_ucc.style.left = `${(thumbPosition_ucc / scrollbarRect_ucc.width) * 100}%`;
  swipeContainer_ucc.scrollTo({
    left: scrollPosition_ucc,
    behavior: 'auto'
  });
}

customScrollbar_ucc?.addEventListener('touchstart', (e) => {
  isDragging_ucc = true;
  moveThumb_ucc(e.touches[0]);
  e.preventDefault();
}, { passive: false });

window.addEventListener('touchmove', (e) => {
  if (isDragging_ucc) {
    moveThumb_ucc(e.touches[0]);
    e.preventDefault();
  }
}, { passive: false });

window.addEventListener('touchend', () => {
  isDragging_ucc = false;
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".video-wrapper").forEach(wrapper => {
      const videoId = wrapper.getAttribute('data-video-id');
      const video = wrapper.querySelector('.ucc-video-player');
      const playIcon = wrapper.querySelector(`.play-icon-${videoId}`);
      const pauseIcon = wrapper.querySelector(`.pause-icon-${videoId}`);
      const thumbnailWrapper = wrapper.querySelector('.thumbnail-wrapper');
        wrapper.addEventListener("click", function (event) {
        if (video.paused) {
          video.play();
          playIcon.classList.add("hidden");
          pauseIcon.classList.remove("hidden");
          if (thumbnailWrapper) {
            thumbnailWrapper.classList.add("hidden");
          }
        } else {
          video.pause();
          playIcon.classList.remove("hidden");
          pauseIcon.classList.add("hidden");
        }
      });
  
      video.addEventListener("pause", function () {
        playIcon.classList.remove("hidden");
        pauseIcon.classList.add("hidden");
      });
  
      video.addEventListener("play", function () {
        playIcon.classList.add("hidden");
        pauseIcon.classList.remove("hidden");
        if (thumbnailWrapper) {
          thumbnailWrapper.classList.add("hidden");
        }
      });
    });
  });
  